import { createNamespacedHelpers } from 'vuex'; 
import { v4 } from "uuid";

let firstBln = false ;

const { 
  mapActions : commNewMapActions , 
  mapGetters : commNewMapGetters , 
  mapMutations : commNewMapMutations , 
  mapState : commNewMapState ,  
} = createNamespacedHelpers('CommNew');

const CommNew = {
  computed : {
    ...commNewMapGetters([
      'processId' , 
      'protocolId' ,
      'pending' , 
      'items' , 
      'crntItem' , 
      'elements' , 
      'localStorageKey' , 
      'LNBOpenBln' , 
      'PROCESS_INFO' , 
      'USER_INFO' , 
      'dragTag' , 
      'LNBTagBalloon' , 
      'LNBTagContextMenu' , 
      '$wApi', 
      'emptyProcess' , 
      'editorProcessMotherElem' , 
      'protocolIssueList' , 
      'slctProtocolKey' , 
      'crntProtocolInfo' , 
      'crntDiagram' , 
      'crntDate' , 
      'saveDuration' ,  
      'status' , 
      'pdfWiki' , 
      'getProtocolCreateFlag' ,
      'getInnerProtocolId' ,
      'getProcessReadOnly',
      'editDuration',
    ]) , 
  } , 
  data () {
    return {

    }
  } , 
  /* watch : {
    elements : {
      immediate : true , 
      handler () {
        console.log( '[ CommonNew elements watch ]' ) ; 
      }
    } , 
  } ,  */
  mounted () {
    window.addEventListener('popstate', this.unmountHandler ) ;
  } , 
  methods : {
    unmountHandler () {
      // console.log( '[CommNew.js -> unmountHandler in]\n') ; 
      this.initHandler() ; 
      window.removeEventListener('popstate', this.unmountHandler ) ;
    } , 
    ...commNewMapActions([
      'initElements' , 
      'setProcess_N_UserInfo' , 
      'addUseTags' , 
      'deleteUseTags' , 
      'LNBTagNameViewHandler' , 
      'getProtocols' , 
      'convertIssuesStringToJSON' , 
      'converStringToJSON' , 
    ]) , 
    ...commNewMapMutations([
      'updateElements' , 
      'setInitInfo' , 
      'initItems' , 
      'LNBopenToggleHandler' , 
      'closeTagWriteComp' , 
      'setPROCESS_INFO',
      'initHandler' , 
      'setProtocolId' , 
      'setProcessId' , 
      'updateState' , 
      'findFromNode' , 
      'setCrntProtocolInfo' , 
      'setCrntDiagram' , 
      'updateProtocols' , 
      'updateStatus' , 
      'updatePdfWiki' , 
      'setProtocolCreateFlag' ,
      'setInnerProtocolId' ,
      'updateProcessInfo',
      'setProcessReadOnly',
    ]) , 
  } , 
} ; 

const typeOfJson = function (data){
  function parsing() {
    if(typeof data !== 'string') return data
    data = JSON.parse(data);
    parsing();
  }
  parsing();
  return data;
}

const replaceAllSpecialChar = function (str) {
  // 변환할 문자 입력.
  const specialCharObj = {
    "&lt;": "<",
    "&gt;": ">",
    "&amp;": "&",
  };
  for (const key in specialCharObj) {
    const value = specialCharObj[key];
    str = str.replaceAll(key,value);
  }
  return str;
}

export default CommNew ; 
export {
  commNewMapActions , 
  commNewMapGetters , 
  commNewMapMutations , 
  commNewMapState , 
  typeOfJson ,
  replaceAllSpecialChar ,
} ; 